module.exports = __webpack_public_path__ + "static/media/Backdrop_Lottery.2c30c090.png";